<template>
	<div class="orderpage">
		<common-header></common-header>
		<div class="text-left flex">
			<div class="left-menu">
				<ul class="side-nav">
					<li class="nav-item">
						<a>个人中心</a>
						<ul>
							<li class="nav-item"><el-link @click="toPage('/userManage')">个人中心</el-link></li>
						</ul>
					</li>
					<li class="nav-item">
						<a>订单中心</a>
						<ul>
							<li class="nav-item"><el-link @click="tabChange(1)">待付款</el-link></li>
							<li class="nav-item"><el-link @click="tabChange(2)">待发货</el-link></li>
							<li class="nav-item"><el-link @click="tabChange(3)">待评价</el-link></li>
							<li class="nav-item"><el-link @click="tabChange(4)">退款售后</el-link></li>
						</ul>
					</li>
				</ul>
			</div>
			<div class="right-container">
				<div class="page-title backcolor padding">我的订单</div>
				<div class="order-container">
					<div class="backcolor padding">
						<el-button-group class="menu-btn">
							<el-button type="text" :class="{ active: tabCurrentIndex == 0 }" @click="tabChange(0)">全部订单</el-button>
							<el-button type="text" :class="{ active: tabCurrentIndex == 1 }" @click="tabChange(1)">待付款</el-button>
							<el-button type="text" :class="{ active: tabCurrentIndex == 2 }" @click="tabChange(2)">待收货</el-button>
							<el-button type="text" :class="{ active: tabCurrentIndex == 3 }" @click="tabChange(3)">待评价</el-button>
							<el-button type="text" :class="{ active: tabCurrentIndex == 4 }" @click="tabChange(4)">退款/售后</el-button>
						</el-button-group>
					</div>
					<div>
						<template v-if="orderList.length">
							<div class="order-item backcolor" v-for="(item, index) in orderList" :key="index">
								<p class="th padding">
									<span>{{ ctimeToDate(item.ctime) }}</span>
									<span>订单号：{{ item.order_no }}</span>
									<span class="color-red" v-if="item.status == 1">{{ item.remain_time_tip }}</span>
								</p>
								<div class="flex item-border">
									<div class="goods-info">
										<div v-for="(goods, index) in JSON.parse(item.orderinfo)" :key="index" class="goods-item">
											<div class="flex">
												<img class="smpic" :src="getWebPic(goods.smpic)" />
												<div class="goods-title"><el-link @click="toPage('/goods/goodsDetail','id='+goods.goods_id)">{{ goods.title }}</el-link></div>
												<div class="param-num">
													<div class="param">
														<span>{{ goods.param1 }}</span>
														<span>{{ goods.param2 }}</span>
													</div>
													<div class="num">{{ goods.number }}</div>
												</div>
											</div>
										</div>
									</div>
									<div class="user-address">
										<el-tooltip placement="left" effect="light">
											<template #content>
												{{ item.shouhuo_name }}
												<br />
												{{ item.full_address }}
												<br />
												{{ item.shouhuo_tel }}
											</template>
											<div>
												{{ item.shouhuo_name }}
												<i class="el-icon-user"></i>
											</div>
										</el-tooltip>
									</div>
									<div class="order-pay">
										<div class="pay">{{ item.needpay }}</div>
										<div class="pay-type">{{ item.pay_type ? '货到付款' : '在线支付' }}</div>
									</div>
									<div class="order-status">
										<div :style="{ color: item.stateTipColor }">{{ item.stateTip }}</div>
									</div>
									<div class="operate">
										<div class="action-box b-t" v-if="item.status == 0">
											<span class="block">
												<el-button type="default" size="mini" icon="el-icon-delete" @click="deleteOrder(item)">删除订单</el-button>
											</span>
										</div>
										<div class="action-box b-t" v-if="item.status == 1">
											<template v-if="item.remain_time > 0">
												<span class="block">
													<el-button type="warning" size="mini" @click="orderPay(item)">立即支付</el-button>
												</span>
											</template>
											<span class="chaoshi_tip" v-else>{{ item.remain_time_tip }}</span>
											<span class="block" v-if="item.remain_time">
												<el-button type="danger" size="mini" @click="cancelOrder(item)">取消订单</el-button>
											</span>
											<span v-else class="block">
												<template v-if="loaded">
													<el-button type="default" size="mini" icon="el-icon-delete" @click="deleteOrder(item)">删除</el-button>
												</template>
											</span>
										</div>
										<div class="action-box b-t" v-if="item.status == 2">
											<templete v-if="item.wuliu_sn" class="action-box b-t">
												<button class="action-btn" @click="wuliu(item)">查看物流</button>
												<button class="action-btn recom" @click="shouhuo(item)">确认收货</button>
												<button class="action-btn recom" @click="tuikuan(item)">申请退款</button>
											</templete>
											<templete v-else class="action-box b-t">
												<button class="action-btn" @click="tixing(item)">提醒发货</button>
												<button class="action-btn recom" @click="tuikuan(item)">申请退款</button>
											</templete>
										</div>
										<div class="action-box b-t" v-else-if="item.status == 3">
											<button class="action-btn" @click="wuliu(item)">查看物流</button>
											<button class="action-btn recom" @click="toPingjia(tabIndex, index)">评价</button>
										</div>
										<div class="action-box b-t" v-else-if="item.status == 4">
											<span v-if="item.refund_status == 0" style="color:#fa436a;font-size: 12px;">等待商家处理</span>
											<span v-else-if="item.refund_status == 1" style="color: #4CD964;font-size: 12px;">已退款</span>
											<span v-else-if="item.refund_status == 2" @click="showRefundReason(item)" style="color: red;font-size: 12px;">申请被拒绝,查看原因>></span>
										</div>
										<div class="action-box b-t" v-else-if="item.status == 9"><button class="action-btn" @click="wuliu(item)">查看物流</button></div>
									</div>
								</div>
							</div>
						</template>
						<div v-else class="text-center backcolor">
							<img src="../../assets/no-order.png" />
							<p>暂无相关订单</p>
						</div>
					</div>
					<div class="block" v-if="orderList.length">
						<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							:current-page="thispage"
							:page-sizes="pageSizes"
							:page-size="pagesize"
							layout="total, sizes, prev, pager, next, jumper"
							:total="total"
						></el-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import commonHeader from '../../components/common/commonHeader.vue';
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
	name: '',
	components: {
		commonHeader
	},
	data() {
		return {
			tabCurrentIndex: 0, //当前选中tab的index
			thispage: 1,
			total: 0,
			pagesize: 30, //每页显示条数
			pageSizes: [30], //每页显示个数选择器
			orderList: [],
			loaded:true
		};
	},
	computed: {
		...mapState({
			loginState: state => state.user.loginState,
			userInfo: state => JSON.parse(state.user.userInfo)
		})
	},
	mounted() {
		let query = this.$route.query;
		this.tabCurrentIndex = Number(query.state);
		this.getOrderList();
	},
	methods: {
		tabChange(index) {
			this.tabCurrentIndex = index;
			this.thispage = 1;
			this.total = 0;
			this.getOrderList();
		},
		handleSizeChange(val) {
			console.log(`每页 ${val} 条`);
			this.pagesize = val;
			this.getOrderList();
		},
		handleCurrentChange(val) {
			console.log(`当前页: ${val}`);
			this.thispage = val;
			this.getOrderList();
		},
		getOrderList() {
			let state = this.tabCurrentIndex;
			this.$request
				.post('/home.order/orderList', {
					user_id: this.userInfo.id,
					userid: this.userInfo.id,
					token: this.userInfo.token,
					page: this.thispage,
					pagesize: this.pagesize,
					status: state
				})
				.then(res => {
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'userinfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						let list = res.data.list.data;
						console.log(list)
						let orderList = list.filter(item => {
							//添加不同状态下订单的表现形式
							if (item.status == 5) {
								item.status = 4;
							}
							item = Object.assign(item, this.orderStateExp(item.status), { remain_time: 0, remain_time_tip: '' });
							//演示数据所以自己进行状态筛选
							if (state === 0) {
								//0为全部订单
								return item;
							}
							return item.status === state;
						});
						this.orderList = orderList;
						this.total = res.data.list.total;
						if (orderList.length) {
							this.startIntval = true;
							this.remainTime();
						}
						console.log(this.orderList);
					}
				})
				.catch(err => {});
		},
		//订单状态文字和颜色
		orderStateExp(state) {
			let stateTip = '',
				stateTipColor = '#fa436a';
			switch (+state) {
				case 0:
					stateTip = '已取消';
					stateTipColor = '#909399';
					break;
				case 1:
					stateTip = '待付款';
					break;
				case 2:
					stateTip = '待收货';
					break;
				case 3:
					stateTip = '待评价';
					break;
				case 4:
					stateTip = '售后订单';
					stateTipColor = '#909399';
					break;
				case 9:
					stateTip = '交易成功';
					break;

				//更多自定义
			}
			return { stateTip, stateTipColor };
		},
		// 待付款订单倒计时
		remainTime() {
			this.loaded = false;
			let orderList = this.orderList;
			if (orderList.length) {
				var list = [];
				this.timer = setInterval(() => {
					list = orderList;
					if (this.tabCurrentIndex >= 2) {
						return;
					}
					for (let i in list) {
						let thistime = Math.floor(new Date().getTime() / 1000); //当前秒数
						let fukuan_time = list[i].ctime + 1800; //下单时间+半小时的秒数
						let remain_time = fukuan_time - thistime; //获取剩余秒数
						if (remain_time > 0) {
							orderList[i].remain_time = remain_time;
							//console.log(orderList[i].remain_time);
							orderList[i].remain_time_tip = '付款时间剩余:' + Math.floor(remain_time / 60) + '分' + (remain_time % 60) + '秒';
						} else {
							orderList[i].remain_time_tip = '订单超时已取消';
						}
					}
				}, 1000);
			}
			this.loaded = true;
		},
		//取消订单
		cancelOrder(item) {
			this.$confirm('确定要取消订单吗？')
				.then(_ => {
					this.$emit('showLoading', true);
					this.$request
						.post('/home.order/cancelOrder', {
							userid: this.userInfo.id,
							token: this.userInfo.token,
							order_id: item.id,
							buyType: '' //区别于团购订单的
						})
						.then(res => {
							console.log(res.data);
							this.$emit('showLoading', false);
							this.$message.success(res.data.msg);
							if (res.data.status == 0) {
								this.$message.error(res.data.msg);
								if (res.data.admin_err == 'userinfo_error') {
									this.exit().then(res => {
										console.log(res);
										if (res.actionStatus == 1) {
											this.$router.push('/login');
										}
									});
								}
							} else {
								this.getOrderList();
							}
						})
						.catch(err => {
							this.$emit('showLoading', false);
						});
				})
				.catch(_ => {});
		},
		//删除订单
		deleteOrder(item) {
			this.$confirm('确定要取消订单吗？')
				.then(_ => {
					this.$emit('showLoading', true);
					this.$request
						.post('/home.order/deleteOrder', {
							userid: this.userInfo.id,
							token: this.userInfo.token,
							order_id: item.id,
							buyType: '' //区别于团购订单的
						})
						.then(res => {
							console.log(res.data);
							this.$emit('showLoading', false);
							this.$message.success(res.data.msg);
							if (res.data.status == 0) {
								this.$message.error(res.data.msg);
								if (res.data.admin_err == 'userinfo_error') {
									this.exit().then(res => {
										console.log(res);
										if (res.actionStatus == 1) {
											this.$router.push('/login');
										}
									});
								}
							} else {
								this.getOrderList();
							}
						})
						.catch(err => {
							this.$emit('showLoading', false);
						});
				})
				.catch(_ => {});
		},
	}
};
</script>
<style lang="scss">
.el-main {
	.orderpage {
		background-color: #f0f3ef !important;
	}
	.left-menu {
		width: 170px;
		background-color: #fff;
		.side-nav {
			> .nav-item {
				padding: 15px 20px;
				border-bottom: 1px solid #f3f3f3;
				a {
					font-size: 15px;
					font-weight: bold;
					text-decoration: none;
					line-height: 40px;
				}
				.nav-item {
					a {
						font-size: 14px;
						line-height: 30px;
						&:hover {
							cursor: pointer;
						}
					}
				}
			}
		}
	}
	.right-container {
		flex: 1;
		padding: 20px 0 0 20px;
		background-color: #f0f3ef !important;
		.backcolor {
			background-color: #fff;
		}
		.padding {
			padding: 0 15px;
		}
		.page-title {
			line-height: 40px;
		}
		.order-container {
			margin-top: 15px;
			// margin-left: 15px;
			.menu-btn {
				button {
					color: dimgray;
					padding: 0 10px;
					line-height: 35px;
					&:hover {
						color: $base-color;
					}
					&.active {
						color: $base-color;
						border-bottom: 2px solid $base-color;
					}
				}
			}
			.order-item {
				margin-top: 10px;
				border: 1px solid #dddddd;
				.th {
					background-color: #e1e1e1;
					font-size: 14px;
					line-height: 35px;
					span + span {
						margin-left: 15px;
					}
				}
				.item-border {
					> div {
						border-right: 1px solid #dddddd;
						padding-top: 15px;
						text-align: center;
						&:first-child{
							padding:  0 15px;
							text-align: left;
						}
						&:first-child {
							padding-top: 0;
						}
						&:last-child {
							border-right: none;
						}
					}
				}
				.goods-info {
					flex: 1;
					.goods-item {
						border-bottom: 1px solid #dddddd;
						&:last-child {
							border: none;
						}
						padding: 15px 0;
						.smpic {
							width: 60px;
							height: 60px;
						}
						.goods-title {
							flex: 1;
							padding-left: 15px;
						}
						.param-num {
							padding: 0 15px;
							text-align: center;
							color: gray;
							font-size: 14px;
							line-height: 30px;
							.num {
								&::before {
									content: 'x';
									margin-right: 3px;
								}
							}
						}
					}
				}

				.user-address {
					width: 85px;
					line-height: 30px;
					&:hover {
						cursor: pointer;
					}
				}
				.order-pay {
					width: 90px;
					line-height: 30px;
					text-align: center;
					.pay {
						border-bottom: 1px solid #ccc;
						&::before {
							content: '￥';
						}
					}
				}
				.order-status{
					width: 82px;
				}
				.operate {
					width: 120px;
					text-align: center;
					.chaoshi_tip {
						font-size: 13px;
						color: #cccccc;
					}
					.block{
						display: block;
						+.block{
							margin-top: 10px;
						}
					}
					
				}
			}
		}
	}
}
</style>
